(function(){
     'use strict';

     angular
        .module('app')
        .factory('AttributeformService', AttributeformService);

    AttributeformService.$inject = ['$http'];

    function AttributeformService($http){
        
        var service= {
            getparentAttribute:getparentAttribute,
            parentId:parentId,
            SaveForm:SaveForm
        };

        function getparentAttribute(vm){
            var config = {
                headers : {
                }
            }
            
            return $http.get('/ajax/parentattribute', {params : {
                lang_id:lang_id              
             } }, config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function parentId(parent_id){

            var config = {
                headers : {}
            }

            return $http.get('/ajax/attributeseleccionado', { 
                params : { 
                    lang_id:lang_id,
                    parent_id:parent_id
                } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function SaveForm(vm){
            var config = {
                headers : {
                }
            }
            
            return $http.post('/ajax/sendformpasos', {
                json:JSON.stringify(vm.json),
                lang_id:lang_id
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

           return service;
    }

     
})();